import { useNavigate } from "react-router-dom";

const useNavigateTo = () => {
    let navigate = useNavigate();

    const navigateTo = (url) => {
        navigate(url);
    };

    return navigateTo;
};

export default useNavigateTo;
